import { Container } from '@crehana/ui';
import { Loadable } from '@crehana/web';

import DashboardErrorView from '@/views/UserDashboard/components/DashboardTemplate/DashboardErrorView';

import CollapsedListSkeleton from '../../components/CollapsedListSkeleton';

const LazyBundles = () => (
  <Loadable
    Loader={
      <Container type="dashboard">
        <CollapsedListSkeleton />
      </Container>
    }
    ErrorFallback={
      <Container type="dashboard">
        <DashboardErrorView defaultConnectionError supportsDarkMode />
      </Container>
    }
    module={() =>
      import(/* webpackChunkName: "user-dashboard-bundles" */ './Bundles')
    }
  />
);

export default LazyBundles;
